export default __webpack_public_path__ + "static/media/trophy-silver.ff36ff27.svg";